var map = {
	"./info-sharing-accounts-de.html": 1005,
	"./info-sharing-accounts-en.html": 1006,
	"./info-sharing-accounts-es.html": 1007,
	"./info-sharing-accounts-fr.html": 1008,
	"./info-sharing-accounts-ja.html": 1009,
	"./info-sharing-accounts-pt.html": 1010,
	"./info-sharing-accounts-zh.html": 1011
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1004;


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-accounts ^\.\/info\-sharing\-accounts\-.*\.html$
// module id = 1004
// module chunks = 0